export default {
	rooms: {
		rooms: 'Rozmowy',
		public: 'Publiczne',
		roomsPublic: 'Rozmowy publiczne',
		roomsPrivate: 'Rozmowy prywatne',
		private: 'Prywatne',
		noRooms: 'Brak rozmów'
	},
	room: {
		room: 'Rozmowa',
		public: 'Publiczny',
		roomPublic: 'Rozmowa publiczna',
		group: 'Grupowy',
		chatGroup: 'Czat grupowy',
		groupRoom: 'Czat grupowy',
		newGroupRoom: 'Nowy czat grupowy',
		private: 'Prywatny',
		roomPrivate: 'Rozmowa prywatna',
		newRoom: 'Nowa rozmowa',
		open: 'Otwarty',
		closed: 'Zamknięty',
		direct: 'Bezpośrednia',
		roomDirect: 'Rozmowa bezpośrednia'
	},
	messages: {
		addFirstMessage: 'Napisz pierwszą wiadomość',
		startTyping: 'Napisz wiadomość...',
		messages: 'Wiadomości',
		private: 'Prywatne',
		privateMessages: 'Wiadomości prywatne',
		unreadMessages: 'Nieprzeczytane wiadomości',
		newMessage: 'Nowa wiadomość',
		searchPlaceholder: 'Wyszukaj wiadomości...',
		openInMessenger: 'Otwórz w messengerze',
		popupNotFit: 'Otwarte rozmowy nie mieszczą się na ekranie.',
		wannaOpenInMessenger: 'Czy chcesz otworzyć tę wiadomość w messengerze?',
		newMessages: 'Nowe wiadomości',
		delete: 'Usuń wiadomość',
		confirmDelete: 'Na pewno chcesz usunąć wiadomość',
		successfullyEdited: 'Pomyślnie zapisano zmiany',
		noUnreadMessages: 'Brak nieprzeczytanych wiadomości',
		allMessages: 'Wszystkie wiadomości',
		noMessages: 'Brak wiadomości',
	},
	images: {
		delete: 'Usuń zdjęcie',
		confirmDelete: 'Na pewno chcesz usunąć zdjęcie?'
	},
	attachment: {
		delete: 'Usuń załącznik',
		confirmDelete: 'Na pewno chcesz usunąć załącznik?'
	},
	expand: 'Rozszerz okno',
	clickToStart: 'Kliknij czat, aby rozpocząć',
	errors: {
		tooManyExpanded: 'Zbyt wiele otwartych okien',
	},
	goToChat: 'Przejdź do rozmowy',
	minimize: 'Zwiń',
	returnToList: 'Powrót do listy',
	you: 'Ty',
	searchMultipleUsers: 'Znajdź osoby',
	membersCount: 'Członków',
	read: 'Przeczytano',
	displayed: 'Wyświetlono',
	addUser: 'Dodaj użytkownika',
	addUsers: 'Dodaj użytkowników',
	usersList: 'Lista użytkowników',
	isTyping: 'pisze',
	usersTyping: 'osoby piszą'
}
